const PageNotFound = () => {
  return (
    <div className='w-full h-full flex justify-center items-center flex-col gap-6'>
      <h1>Page not found!</h1>
    </div>
  );
};

export default PageNotFound;
